import { FC, useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSSVariableValue } from '../../../../../../_metronic/assets/ts/_utils'

type Props = {
  data: Array<{ name: string; value: number }>
  height?: number
}

const PostsStatusChart: FC<Props> = ({ data, height = 350 }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!chartRef.current) return

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, data))
    if (chart) {
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [data, height])

  return <div ref={chartRef}></div>
}

export { PostsStatusChart }

const getChartOptions = (
  height: number,
  data: Array<{ name: string; value: number }>
): ApexOptions => {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const successColor = getCSSVariableValue('--bs-success')
  const infoColor = getCSSVariableValue('--bs-info')

  const colors = [successColor, infoColor]

  return {
    series: data.map((d) => d.value),
    chart: {
      fontFamily: 'inherit',
      type: 'donut',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '75%',
        },
      },
    },
    colors: colors,
    stroke: {
      show: true,
      width: 2,
      colors: ['#fff'],
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
 
        },
      },
      active: {
        filter: {
          type: 'darken',
 
        },
      },
    },
    legend: {
      position: 'bottom',
      labels: {
        colors: labelColor,
      },
    },
    labels: data.map((d) => d.name),
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '12px',
      },
    },
  }
}
